import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";

const CustomTooltip = ({ active, payload, label, metric }) => {
  if (active && payload && payload.length) {
    const date = new Date(label);
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: 10,
          border: "1px solid #ccc",
        }}
      >
        <p>
          <strong>{date.toDateString()}</strong>
        </p>
        <p>{`${metric}: ${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

function TimelineChart({ data, metric }) {
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
    });
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart
        data={data}
        margin={{ top: 20, right: 40, left: 20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="time"
          tickFormatter={formatDate}
          angle={-45}
          textAnchor="end"
          height={60}
        />
        <YAxis
          allowDecimals={false}
          domain={["auto", "auto"]}
          label={{ value: metric, angle: -90, position: "insideLeft" }}
        />
        <Tooltip content={<CustomTooltip metric={metric} />} />
        <Legend />
        <Line
          type="monotone"
          dataKey="value"
          stroke="#007acc"
          strokeWidth={2}
          dot={{ r: 3 }}
          activeDot={{ r: 6 }}
          name={metric}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

export default TimelineChart;
